import { Component } from '@angular/core';

@Component({
    selector: 'app-vote',
    templateUrl: './vote.component.html',
    styleUrls: ['./vote.component.scss'],
    standalone: false
})
export class VoteComponent {

  constructor() { }
}
